export const extractItemNumbersFromRedux = (events) => {
	const itemNumbers = [];

	events.forEach((event) => {
		event.events.forEach((subEvent) => {
			try {
				if (
					!subEvent.actual_items ||
					subEvent.actual_items === "null"
				) {
					return;
				}

				const parsedItems = JSON.parse(subEvent.actual_items);

				if (!Array.isArray(parsedItems)) {
					return;
				}

				const numericItems = parsedItems.filter((item) => !isNaN(item));

				itemNumbers.push(...numericItems);
			} catch (error) {
				console.error("Error parsing actual_items:", error);
			}
		});
	});

	return [...new Set(itemNumbers)];
};
